<template>
  <div class="_modals">
    <b-modal
      id="modalUploadDocument"
      ref="modalUploadDocument"
      centered
      hide-footer
      @hidden="resetModalUploadDoc"
      :title="this.status ? 'Replace Document' : 'Upload Document'"
    >
      <div>
        <div
          class="input__dragdrop"
          v-if="!Boolean(formDoc.fileDocument)"
          id="errorfile"
        >
          <b-form-file
            v-model="formDoc.fileDocument"
            v-validate="'required'"
            name="fileDocumentShipment"
            :state="
              errors.first('fileDocumentShipment') &&
                Boolean(formDoc.fileDocument)
            "
            accept=".pdf, .xls, .doc, .docx, .xlsx, .png, .jpeg"
            drop-placeholder="Drop file here..."
          >
            <template slot="placeholder">
              <img
                class="input__dragdrop--img"
                src="@/assets/image/icon/icon-upload-drag-drop.svg"
                alt=""
              />
              <p class="mt-3">
                Drag your file here or
                <u style="color: #1E3354; font-weight: 700">Choose file</u>
              </p>
              <p style="color: #C4232A">*Maximum 5 MB</p>
            </template>
          </b-form-file>
          <p class="textinfo text-left">{{ errorFormDoc.fileInput }}</p>
        </div>
        <div v-else-if="!statusForm">
          <p class="pb-1">Document Upload</p>
          <div
            class="input__dragdrop text-center p-4"
            style="border: 1px dashed rgb(196, 35, 42);"
          >
            <img
              class="input__dragdrop--img"
              src="@/assets/image/icon/icon-upload-drag-dropred.svg"
              alt=""
            />
            <p
              class="mt-3"
              style="color:rgb(196, 35, 42);font-style: normal;font-weight: normal;"
            >
              Sorry, your file is too big. Please upload file with maximum 5 MB.
              <br />
              <u
                style="color: #1E3354; font-weight: 700"
                @click="resetModalUploadDoc()"
                >Choose file</u
              >
            </p>
          </div>
        </div>
        <div v-else>
          <div v-if="statusForm">
            <div
              v-if="
                !progressBar.status &&
                  showProgressText(progressBar.value, progressBar.max) <= 100
              "
            >
              <p class="mb-2 text-left">Uploading</p>
              <b-progress :max="progressBar.max" show-progress>
                <b-progress-bar
                  :value="progressBar.value"
                  :label="
                    `${showProgressText(
                      progressBar.value,
                      progressBar.max
                    )}% Uploading...`
                  "
                ></b-progress-bar>
              </b-progress>
              <p class="mt-1 text-left">Uploading your file, please wait...</p>
            </div>
            <div v-else>
              <p class="text-left">Your File</p>
              <div class="d-flex mt-2 text-left">
                <p
                  class="py-1"
                  style="cursor: pointer"
                  @click="resetModalUploadDoc()"
                >
                  <b><i>X</i></b>
                </p>
                <img
                  class="pl-2"
                  src="@/assets/image/icon/icon-file.svg"
                  alt=""
                />
                <p class="pl-2 py-1">
                  <i style="word-break: break-all;">{{
                    formDoc.fileDocument ? formDoc.fileDocument.name : ''
                  }}</i>
                </p>
              </div>
              <button
                @click="handleUploadDoc"
                class="button__bluecorporite mt-2"
                style="width: 100%;"
              >
                <span v-if="isLoadingPostSubmit">upload is process...</span>
                <span v-else>Upload File</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modalReplaceConfirmation"
      ref="modalReplaceConfirmation"
      title="Replace Document"
      centered
      hide-footer
    >
      <div class="text-center">
        <img src="@/assets/image/icon/Notice.svg" alt="" />
        <p class="mb-2">
          This action will erase previous uploaded document permanently
        </p>
        <b>
          Are you sure wants to replace the current document with the new
          one?</b
        >
        <div class="mt-4 d-flex justify-content-between">
          <button @click="toUpload" class="button__bluecorporite">
            Yes
          </button>
          <button @click="closeModal" class="button__redcorporite">
            No
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modalSuccessUpload"
      ref="modalSuccessUpload"
      hide-footer
      hide-header-close
      centered
    >
      <div class="text-center">
        <img class="mb-2" src="@/assets/image/icon/success-blue.svg" alt="" />
        <p class="mb-2">Upload Success</p>
        <button @click="closeSuccessModal" class="button__bluecorporite">
          Ok
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'OptionModal',
  data() {
    return {
      status: false,
      type: '',
      titleModal: '',
      title1: '',
      title2: '',
      formDoc: {},
      progressBar: {
        value: 0,
        max: 0,
        status: false
      },
      statusForm: true,
      errorFormDoc: {
        fileInput: '',
        fileChategory: '',
        replyTo: '',
        desc: ''
      },
      modeOption: '',
      addressId: '',
      isLoadingPostSubmit: false
    };
  },
  created() {
    this.$eventHub.$on('dialog-modal-document', this.dialogUpload);
    this.$eventHub.$on(
      'dialog-confirmation-reupload',
      this.dialogConfirmationUpload
    );
  },
  beforeDestroy() {
    this.$eventHub.$off('dialog-modal-document');
    this.$eventHub.$off('dialog-confirmation-reupload');
  },
  computed: {
    formFile() {
      return this.formDoc.fileDocument;
    }
  },
  methods: {
    dialogUpload(payload) {
      this.$refs.modalUploadDocument.show();
      this.type = payload.type;
      this.status = payload.status;
    },
    dialogConfirmationUpload(payload) {
      this.$refs.modalReplaceConfirmation.show();
      this.type = payload.type;
      this.status = payload.status;
    },
    toUpload() {
      this.closeModal();
      this.$refs.modalUploadDocument.show();
    },
    closeModal() {
      this.$refs.modalReplaceConfirmation.hide();
    },
    closeSuccessModal() {
      this.$refs.modalSuccessUpload.hide();
    },
    resetModalUploadDoc() {
      this.formDoc.fileDocument = null;
      this.formDoc.documentDesc = '';
      this.formDoc.documentCategory = '';
      this.statusForm = true;
      this.progressBar = {
        value: 0,
        max: 0,
        status: false
      };
      this.errorFormDoc = {
        fileInput: '',
        fileChategory: '',
        replyTo: '',
        desc: ''
      };

      this.upload_error = false;
      this.mgshipementCategoryValue = 'File Category';
      this.replyToValue = '';
      this.closeModal();
    },
    chkInputFile() {
      if (this.formDoc.fileDocument.size <= 5242880) {
        this.isActive = true;
      } else {
        this.statusForm = false;
      }
    },
    startTimer() {
      let byte = 102400; // 100 kb to byte
      const vm = this.progressBar;
      const timer = setInterval(() => {
        // set kecepatan progress
        if (vm.max > 1048576) {
          // 1MB
          byte = 1048576;
        } else if (vm.max < 102400) {
          byte = 10240; // 10KB
        }
        // kalo ada ekor angka yang < byte, langsung nambain ekornya biar progress 100%
        if (vm.value + byte > vm.max) {
          vm.value += vm.max % byte;
        } else {
          vm.value += byte;
        }
        if (vm.value >= vm.max) {
          clearInterval(timer);
          vm.status = true;
        }
      }, 1000);
    },
    showProgressText(start, max) {
      return ((start / max) * 100).toFixed(0);
    },
    async handleUploadDoc() {
      this.isLoadingPostSubmit = true;
      const formData = new FormData();
      formData.append('uploadedBy', 'USER');
      formData.append('fileDocument', this.formDoc.fileDocument);
      formData.append('documentType', this.type);
      await this.$store
        .dispatch('file/UPLOAD_COMPANY_DOCUMENT', formData)
        .then(() => {
          this.isLoadingPostSubmit = false;
          this.resetModalUploadDoc();
          this.$refs.modalUploadDocument.hide();
          this.$store.dispatch('settingDocs/FETCH_DOCS');
          this.$refs.modalSuccessUpload.show();
        });
    }
  },
  watch: {
    formFile(data) {
      if (data !== null) {
        this.progressBar.max = data.size;
        this.chkInputFile();
        if (this.statusForm) {
          this.startTimer();
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/global/modals/DocumentModal.vue